<template>
  <div class="login">
    <div class="container">
      <div class="wrapper">
        <el-card class="card">
          <h4 class="title">FSK订货系统</h4>
          <el-form :rules="rules" :model="params" ref="uForm" class="form-inline">
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model="params.mobile" placeholder="请输入手机号"> </el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <el-input v-model="params.code" placeholder="验证码">
                <template slot="suffix">
                  <el-button @click="sendCode" :disabled="codeDisabled" size="mini">
                    {{ codeText }}
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button style="width: 100%" type="primary" @click="onSubmit">登录</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import storage from 'store'
import { login, sendSmsCode } from '@/api/index'
import expirePlugin from 'store/plugins/expire'
storage.addPlugin(expirePlugin)

export default {
  data() {
    return {
      params: {
        mobile: '',
        code: ''
      },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{4}$/, message: '请输入正确的验证码', trigger: 'blur' }
        ]
      },
      codeText: '发送验证码',
      codeDisabled: false,
      time: 60
    }
  },
  methods: {
    sendCode() {
      this.$refs.uForm.validateField('mobile', (err) => {
        if (!err) {
          this.codeDisabled = true
          sendSmsCode({ mobile: this.params.mobile })
            .then((res) => {
              this.$message.success('发送成功')
              this.startTimer()
            })
            .catch((err) => {
              console.log('sendSmsCode', err)
              this.$message.error(err.msg || '发送失败')
            })
        }
      })
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time--
          this.codeText = `${this.time}秒后重新获取`
        } else {
          this.codeDisabled = false
          this.time = 60
          this.codeText = `重新发送`
          clearInterval(this.timer)
        }
      }, 1000)
    },
    // 登录
    onSubmit() {
      this.$refs.uForm.validate((valid) => {
        if (valid) {
          login({ ...this.params })
            .then((res) => {
              const { token, expire } = res.data
              storage.set('token', token, new Date().getTime() + expire * 1000)
              this.$router.push({ path: '/order' })
            })
            .catch((err) => {
              console.log(err)
              this.$message.error(err.msg || '登录失败')
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  justify-content: center;
  background: url('~@/assets/bg_1.jpg') no-repeat center/cover;
}
.container {
  display: flex;
  justify-content: center;
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 100px);
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
}
.card {
  width: 380px;
}
@media screen and (max-width: 991px) {
  .wrapper {
    width: 100%;
  }
  .card {
    width: 100%;
  }
}
@media screen and (max-width: 1199px) {
  .container {
    width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    width: 1200px;
  }
}
</style>
